import { SVGProps } from 'react';

export function RightArrow({ ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g id="Icon" clipPath="url(#clip0_20021_96380)">
				<path
					id="Vector"
					d="M6.61578 2.98859C7.10578 2.49859 7.89578 2.49859 8.38578 2.98859L16.6958 11.2986C17.0858 11.6886 17.0858 12.3186 16.6958 12.7086L8.38578 21.0186C7.89578 21.5086 7.10578 21.5086 6.61578 21.0186C6.12578 20.5286 6.12578 19.7386 6.61578 19.2486L13.8558 11.9986L6.60578 4.74859C6.12578 4.26859 6.12578 3.46859 6.61578 2.98859Z"
					fill="#046A38"
				/>
			</g>
		</svg>
	);
}
